import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import HeaderMobile from 'components/HeaderMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Text, Strong, SimpleButton, Icon } from './styles';
type Props = {
  error?: Error | string;
  show: boolean;
  onClose: () => void;
  onBack: () => void;
};

const FlightsExchangeError = ({ show, error, onClose, onBack }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <ApplicationOverlayContent sidebar show={show} onClose={onClose} backgroundColor="#f9f9f9" zIndex={17}>
      <HeaderMobile goBack={onBack} title={t('flightsExchange.search.header')} onClose={onClose} />
      <Container>
        {error ? (
          <>
            <Text>
              <Icon />
              {t('flightsExchange.error.generic.title')}
            </Text>
            <Text>
              <Strong>{t('flightsExchange.error.tryAgain')}</Strong>
            </Text>
          </>
        ) : (
          <>
            <Text>
              <Icon />
              {t('flightsExchange.error.noResults.title')}
            </Text>
            <Text>
              {t('flightsExchange.error.noResults.text')}
              <br />
              <Strong>{t('flightsExchange.error.tryAgain')}</Strong>
            </Text>
          </>
        )}
        <Text>
          <SimpleButton onClick={onClose} value={t('flightsExchange.error.button')} />
        </Text>
      </Container>
    </ApplicationOverlayContent>
  );
};

export default FlightsExchangeError;
